<template>
    <div v-if="!!Numbers.length" class="number_container">
        <template v-for="(el, index) in Numbers" :key="index">
            <div v-if="el.number !== '0'" class="number_content">
                <div class="number_button_open">
                    <button @click="toggleDetails(index)">
                        {{ detailsOpenStates[index] ? "-" : "+" }}
                    </button>
                </div>
                <div :class="{ number: true, borders: detailsOpenStates[index] }">
          <span class="number_header">
            {{ $t(`page.integration.numbers_table.connected_header[0]`) }}</span
          >
                    <div class="number_help">
                        <img
                            width="17"
                            :src="
                require(`@/assets/icons/${
                  messenger.value ? messenger.value : el.source
                }.svg`).default
              "
                        />
                        <div class="number_with_tags">
                            <span class="number_subtitle" v-text="el.number"/>
                            <BaseTag :tag="el.tags[0]" typeClass="table"/>
                        </div>
                    </div>
                </div>
                <div class="number_info" :class="tableType" v-if="detailsOpenStates[index]">
                    <div v-show="tableType !== 'webhook'" class="myCRM borders">
                        <span class="number_header"> CRM </span>
                        <div
                            class="number_subtitle"
                            v-if="!!el.integrations.length"
                            v-for="(nextEl, nextIndex) in el.integrations"
                            :key="nextIndex"
                        >
                            {{ $t(nextEl) }}
                        </div>
                        <div class="number_subtitle" v-else>-</div>
                    </div>
                    <div v-if="tableType !== 'webhook'" class="tariffs borders tariff-date">
            <span class="number_header">
              {{ $t(`page.integration.numbers_table.tariff_end_date`) }}
            </span>
                        <div class="number_subtitle">
                            {{ el.tariff_end_date || "-" }}
                        </div>
                    </div>
                    <div v-else class="tariffs borders">
            <span class="number_header">
              {{ $t("dialog.webhooks.table.i/o_webhook") }}
            </span>
                        <div class="number_subtitle" v-if="el.webhooks.inbox">
                            {{ truncateText(el.webhooks.inbox, 20) }}
                        </div>
                        <div v-else class="number_subtitle">-</div>
                    </div>
                    <div v-if="tableType !== 'webhook'" class="pay custom-checkbox">
            <span class="number_header">
              {{ $t(`page.integration.numbers_table.connected_header[7]`) }}
            </span>
                        <input
                            v-if="tableType === 'selected'"
                            type="checkbox"
                            :checked="checkIfSelected(el.number, messenger.value)"
                            :id="`сheckbox${
                    messenger.title !== undefined ? messenger.title : el.source
                }${index}`"
                            @change="$emit('toggleSelectionHandler',el, messenger.value || el.source)"
                        />
                        <input
                            v-else
                            type="checkbox"
                            v-model="el.isSelected"
                            :id="`сheckbox${
                messenger.title !== undefined ? messenger.title : el.source
              }${index}`"
                            @change="toggleSelection(el, messenger.value || el.source, index)"
                        />
                        <label
                            :for="`сheckbox${
                messenger.title !== undefined ? messenger.title : el.source
              }${index}`"
                        ></label>
                    </div>
                    <div v-else class="tariffs borders">
            <span class="number_header">
              {{ $t("dialog.webhooks.table.status_webhook") }}
            </span>
                        <div class="number_subtitle" v-if="el.webhooks.status">
                            {{ truncateText(el.webhooks.status, 20) }}
                        </div>
                        <span v-else class="number_subtitle">-</span>
                    </div>
                    <div v-if="tableType === 'webhook'" class="tariffs actions">
            <span class="number_header">{{
                    $t("dialog.webhooks.table.choose_actions")
                }}</span>
                        <div
                            v-if="el.webhooks.inbox && el.webhooks.status"
                            class="btn_container webhook_btn_help"
                        >
                            <button
                                class="webhook_btn edit"
                                style="margin-right: 10px"
                                @click="clickWebhook(el, 'edit')"
                            >
                                <svg
                                    class="w-6 h-6 text-gray-800 dark:text-white webhook_img"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 21 21"
                                >
                                    <path
                                        stroke="#7a70df"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M7.418 17.861 1 20l2.139-6.418m4.279 4.279 10.7-10.7a3.027 3.027 0 0 0-2.14-5.165c-.802 0-1.571.319-2.139.886l-10.7 10.7m4.279 4.279-4.279-4.279m2.139 2.14 7.844-7.844m-1.426-2.853 4.279 4.279"
                                    />
                                </svg>
                            </button>

                            <button class="webhook_btn edit" @click="deleteWebhook(el)">
                                <svg
                                    class="w-6 h-6 text-gray-800 dark:text-white webhook_img"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 18 20"
                                >
                                    <path
                                        stroke="#7a70df"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M1 5h16M7 8v8m4-8v8M7 1h4a1 1 0 0 1 1 1v3H6V2a1 1 0 0 1 1-1ZM3 5h12v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5Z"
                                    />
                                </svg>
                            </button>
                        </div>
                        <div v-else class="webhook_btn_help">
                            <button class="webhook_btn add" @click="clickWebhook(el, 'add')">
                                {{ $t("dialog.webhooks.add_button") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
    <template v-if="tableType !== 'selected'">
        <InfoDataTextRecurring value="noNumbers"/>
    </template>
    <template v-if="tableType === 'selected'">
        <slot name="information_column"/>
        <slot name="pagination"/>
    </template>
</template>
<script>
import InfoDataTextRecurring from "@/components/Recurring/InfoDataTextRecurring.vue";
import BaseTag from "@/components/ui/BaseTag.vue";

export default {
    components: {
        InfoDataTextRecurring,
        BaseTag,
    },
    data() {
        return {
            detailsOpenStates: {},
            selectedNumbers: {
                viber: [],
                telegram: [],
            },
            prevScreenWidth: window.innerWidth,
        };
    },
    props: {
        Numbers: {
            type: Array,
            default: () => [],
        },
        messenger: {
            type: Object,
            default: () => ({}),
        },
        tableType: {
            type: String,
            default: "",
        },
        clickWebhook: {
            type: Function,
            default: null,
        },
        truncateText: {
            type: Function,
            default: null,
        },
        deleteWebhook: {
            type: Function,
            default: null,
        },
        checkIfSelected: {
            type: Function,
            default: () => false,
        }
    },
    methods: {
        toggleDetails(index) {
            this.detailsOpenStates[index] = !this.detailsOpenStates[index];
        },
        toggleSelection(selectedNumber, messenger, index) {
            let numbersArray;
            if (this.$props.tableType === "avans") {
                numbersArray =
                    selectedNumber.source === "viber"
                        ? this.selectedNumbers["viber"]
                        : this.selectedNumbers["telegram"];

                const index = numbersArray.indexOf(selectedNumber.number);

                if (index === -1) {
                    numbersArray.push(selectedNumber.number);
                } else {
                    numbersArray.splice(index, 1);
                }
            } else {
                numbersArray = this.selectedNumbers[messenger];

                const itemExists = numbersArray.some(v => v.number === selectedNumber.number);

                if (!itemExists) {
                    numbersArray.push(selectedNumber);
                } else {
                    numbersArray = numbersArray.filter(v => v.number !== selectedNumber.number);
                }
            }

            this.toggleDetails(index);

            this.$emit("updateNumbersArray", numbersArray, messenger);
        },

        toggleDetailsForAll() {
            this.$props.Numbers.forEach((el, index) => {
                if (window.innerWidth > 640) {
                    this.detailsOpenStates[index] = true;
                } else {
                    this.detailsOpenStates[index] = false;
                }
            });
        },

        handleResize() {
            const currentWidth = window.innerWidth;

            // При изменении размера экрана вызываем toggleDetailsForAll, если необходимо
            if (currentWidth !== this.prevScreenWidth) {
                this.prevScreenWidth = currentWidth;
                this.toggleDetailsForAll();
            }
        },
    },
    mounted() {
        this.toggleDetailsForAll();
        window.addEventListener("resize", this.handleResize);
    },

    unmounted() {
        this.$emit("updateNumbersArray", [], 'viber');
        this.$emit("updateNumbersArray", [], 'telegram');
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
};
</script>
<style scoped lang="scss">
.w-6 {
    width: 15px;
}

.webhook_btn_help {
    display: block;
}

.webhook_btn:hover {
    transition: 0.3s;
    color: white;
    background: var(--general-color);

    .webhook_img path {
        stroke: white;
    }
}

.add {
    padding: 9px 10px;
}

.edit {
    padding: 7px 10px;
}

.webhook_btn {
    font-family: "Gilroy";
    transition: 0.3s;
    border-radius: 9px;
    font-weight: 600;
    background: transparent;
    color: var(--general-color);
    border: 1px solid var(--general-color);
}

.number_button_open {
    width: 27px;
    height: 27px;
    background: white;
    border-radius: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    left: -10px;
    top: 10px;

    button {
        font-size: 20px;
        color: #7a70df;
    }
}

.borders {
    border-bottom: 1px solid #dfdfdf;
}

.tariffs {
    width: 100%;
}

.actions {
    max-width: 140px;
}

.number,
.myCRM,
.tariffs,
.pay {
    display: flex;
    flex-direction: column;
    padding: 10px 25px;
    padding-right: 0;
}

.number_content {
    text-align: left;

    .number {
    }
}

.number {
    padding: 10px 25px;
    padding-right: 0;
    margin-top: -20px;

    &_help {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 10px;
        width: 100%;
        // padding-top: 10px;
    }

    &_header {
        font-family: Gilroy;
        font-size: 14px;
        font-weight: 600;
        line-height: 17px;
        text-transform: uppercase;
        padding-bottom: 7px;
    }

    &_subtitle {
        font-family: Gilroy;
        // font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        text-transform: uppercase;
    }
}

.number_content {
    background-color: var(--block-color);
    border-radius: 7px;
    padding: 0 20px 15px;
    margin-bottom: 10px;
}

.custom-checkbox {
    // min-width: fit-content;
}

.custom-checkbox input[type="checkbox"] {
    display: none;
}

.custom-checkbox label {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid lightgrey;
    cursor: pointer;
    position: relative;
    background: white;
    border-radius: 4px;
}

.custom-checkbox label::after {
    content: "";
    background-image: url("../../assets/tariffs/check.png");
    background-size: contain;
    width: 12px;
    height: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: none;
}

.custom-checkbox input[type="checkbox"]:checked + label::after {
    display: block;
}

@media screen and (min-width: 640px) {
    .webhook_container {
        .number_content .number {
            @media screen and (max-width: 900px) {
                justify-content: flex-start;
            }
        }
    }

    .webhook {
        flex-wrap: wrap;
        justify-content: center !important;
    }

    .actions {
        .number_header {
            display: none;
        }

        .webhook_btn {
            // position: absolute;
        }
    }

    .webhook_btn_help {
        display: flex;
        justify-content: center;
    }

    .custom-checkbox {
        width: 50%;

        & label {
            margin: 0 auto;
            // width: 45px;
            // height: 45px;

            &::after {
                // width: 25px;
                // height: 25px;
            }
        }
    }

    .number,
    .myCRM,
    .tariffs,
    .pay {
        padding: 10px;
        justify-content: space-between;
        gap: 15px;
    }

    .myCRM,
    .tariff-date,
    .pay {
        width: 100%;
    }

    .number_container {
        padding-bottom: 0;
    }

    .number_info {
        display: flex;
        justify-content: flex-start;
        flex: 1;
    }

    .number_button_open {
        display: none;
    }

    .number_content {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;

        .number {
            display: flex;
            min-width: 170px;
            margin: 0;
            justify-content: flex-start;

            &_help {
                display: flex;
                justify-content: center;
                align-items: flex-start;
            }

            &_header {
                text-align: center;
            }

            &_subtitle {
                text-align: center;
                font-size: 13px;
            }
        }

        .borders {
            border: none;
        }

        .number_help,
        .number_subtitle {
            padding-bottom: 10px;
            line-height: 19px;
        }

        .number_help > .number_subtitle {
            padding-bottom: 0px;
        }
    }
}

@media screen and (min-width: 900px) {
    .actions {
        .number_header {
            display: block;
        }
    }

    .webhook {
        flex-wrap: nowrap;
        justify-content: flex-start;
    }
}
</style>
